import styled, { useTheme } from 'styled-components';

const StyledSvg = styled.svg`
  height: ${(props) => props.theme.font.size.md};
  width: ${(props) => props.theme.font.size.md};
  border-radius: ${(props) => props.theme.radius.md};
  vertical-align: center;
`;

export const FeedbackIcon = () => {
  const theme = useTheme();

  return (
    <StyledSvg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 2H4C2.89 2 2 2.89 2 4V16C2 17.11 2.9 18 4 18H8V21C8 21.55 8.45 22 9 22H9.5C9.75 22 10 21.9 10.2 21.71L13.9 18H20C21.1 18 22 17.1 22 16V4C22 2.89 21.1 2 20 2ZM9.08 15H7V12.91L13.17 6.72L15.24 8.8L9.08 15ZM16.84 7.2L15.83 8.21L13.76 6.18L14.77 5.16C14.97 4.95 15.31 4.94 15.55 5.16L16.84 6.41C17.05 6.62 17.06 6.96 16.84 7.2Z"
        fill={
          // @ts-ignore @fe-infra This error will disappear after full migration
          theme.palette.contrastHigh
        }
      />
    </StyledSvg>
  );
};
